<template>
  <div>
      <div v-for="peligro in tiposCas" :key="peligro.id">
        <b-modal class="modal-container" size="xl" no-close-on-backdrop no-close-on-esc scrollable centered v-if="modalpeligro" hide-footer :visible.sync="modalpeligro"
          :title="accion + ' CAS'" >

          <template #modal-header-close>
            <b-button @click="(accion = 'Crear'), (modalpeligro = false)" variant="light">
              <i class="fa fa-close fa-lg"></i>
            </b-button>
          </template>

          <form data-vv-scope="formulario-cas">
            <div>
              <b-row>
                <b-col v-if="accion != 'Editar'" lg="5" md="12" sm="5">
                  <label for="buscar">Buscar Componente</label>
                  <b-form-input v-model="searchComponent" type="text"
                    @keyup.enter="searchListarComponentes()"></b-form-input>
                </b-col>
                <b-col v-if="accion != 'Editar'" lg="3" md="12" sm="3">
                  <b-button class="mt-4" variant="primary" @click="searchListarComponentes()" translate="no">
                    <i class="fa fa-search fa-lg" />
                    <span>Search</span>
                  </b-button>
                </b-col>
                <b-col lg="12" md="12" sm="12">
                  <label>Componente</label>
                  <el-select v-model="peligro.componente" id="componente" name="componente" data-vv-as=" "
                    v-validate="'required'" filterable clearable no-data-text="" no-match-text=""
                    :disabled="accion == 'Editar'">
                    <el-option style="width: 950px;" v-for="comp in componentes" :key="comp.id"
                      :label="comp.cas_complete + ' / ' + comp.name" :value="comp.id">
                      <template v-slot:default>
                        <span v-if="comp.approved == 1">
                          <el-tooltip effect="dark" placement="top" popper-class="py-1 px-2" content="Aprobado">
                            <span class="custom-span-component">
                              <i class="fa fa-check fa-lg"></i>
                            </span>
                          </el-tooltip>
                          {{ comp.cas_number }} / {{ comp.name }}
                        </span>
                      </template>
                    </el-option>
                  </el-select>
                  <span class="text-danger span-error small">
                    {{ errors.first('formulario-cas.componente') }}
                  </span>
                </b-col>
              </b-row>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6 mt-2" v-for="(field, indice) in peligro.danger_fields" :key="indice">
                <div v-if="field.type == 1 && field.active == 1">
                  <label>{{ field.label }}</label>
                  <el-select :disabled="ari" v-model="field.value" :id="field.label + indice"
                    :name="field.label + indice" data-vv-as=" " v-validate="{
                          rules: {
                            required:
                              field.required == 1 &&
                              field.prod_danger_id == peligro.id,
                          },
                        }" filterable multiple>
                    <el-option style="width: 650px;" v-for="list in field.danger_field_lists" :key="list.id"
                      :label="list.lista" :value="list.id"></el-option>
                  </el-select>
                  <span class="text-danger span-error small">
                    {{
                    errors.first('formulario-cas.' + field.label + indice)
                    }}
                  </span>
                </div>

                <div v-if="field.type == 2 && field.active == 1">
                  <label>{{ field.label }}</label>
                  <br />
                  <b-form-radio-group v-model="field.value" :id="field.label + indice" :name="field.label + indice"
                    data-vv-as=" " v-validate="{
                          rules: {
                            required:
                              field.required == 1 &&
                              field.prod_danger_id == peligro.id,
                          },
                        }" buttons :options="[
                          { text: 'SI', value: 1 },
                          { text: 'NO', value: 0 },
                        ]" :button-variant="
                          field.value == 1
                            ? 'outline-primary'
                            : 'outline-secondary'
                        " />
                  <span class="text-danger span-error small">
                    {{
                    errors.first('formulario-cas.' + field.label + indice)
                    }}
                  </span>
                </div>

                <div v-if="field.type == 3 && field.active == 1">
                  <label>{{ field.label }}</label>
                  <el-select v-model="field.value" :id="field.label + indice" :name="field.label + indice"
                    data-vv-as=" " v-validate="{
                          rules: {
                            required:
                              field.required == 1 &&
                              field.prod_danger_id == peligro.id,
                          },
                        }" filterable clearable :disabled="ari">
                    <el-option style="width: 650px;" v-for="list in field.danger_field_lists" :key="list.id"
                      :label="list.lista" :value="list.id"></el-option>
                  </el-select>
                  <span class="text-danger span-error small">
                    {{
                    errors.first('formulario-cas.' + field.label + indice)
                    }}
                  </span>
                </div>

                <div v-if="field.type == 4 && field.active == 1">
                  <label>{{ field.label }}</label>
                  <b-form-input type="number" step="any" min="0" :disabled="ari"
                    onkeypress="return event.charCode>=48 && event.charCode<=57" placeholder="Escriba el año"
                    v-model="field.value" :id="field.label + indice" :name="field.label + indice" data-vv-as=" "
                    v-validate="{
                          rules: {
                            required:
                              field.required == 1 &&
                              field.prod_danger_id == peligro.id,
                          },
                        }" />
                  <span class="text-danger span-error small">
                    {{
                    errors.first('formulario-cas.' + field.label + indice)
                    }}
                  </span>
                </div>

                <div v-if="field.type == 5 && field.active == 1">
                  <label>
                    {{ field.label }}
                  </label>
                  <b-form-input type="number" step="any" min="0" :disabled="ari"
                    onkeypress="return event.charCode>=48 && event.charCode<=57" placeholder="Campo numerico"
                    v-model="field.value" :id="field.label + indice" :name="field.label + indice" data-vv-as=" "
                    v-validate="{
                          rules: {
                            required:
                              field.required == 1 &&
                              field.prod_danger_id == peligro.id,
                          },
                        }" />
                  <span class="text-danger span-error small">
                    {{
                    errors.first('formulario-cas.' + field.label + indice)
                    }}
                  </span>
                </div>

                <div v-if="field.type == 6 && field.active == 1">
                  <label>
                    {{ field.label }}
                  </label>
                  <b-form-input type="number" step="0.1" min="0" :disabled="ari"
                    onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                    placeholder="Campo numerico con decimales" v-model="field.value" :id="field.label + indice"
                    :name="field.label + indice" data-vv-as=" " v-validate="{
                          rules: {
                            required:
                              field.required == 1 &&
                              field.prod_danger_id == peligro.id,
                          },
                        }" />
                  <span class="text-danger span-error small">
                    {{
                    errors.first('formulario-cas.' + field.label + indice)
                    }}
                  </span>
                </div>

                <div v-if="field.type == 7 && field.active == 1">
                  <label>
                    {{ field.label }}
                  </label>
                  <b-form-input type="text" :disabled="ari" placeholder="Campo de texto" v-model="field.value"
                    :id="field.label" :name="field.label" data-vv-as=" " v-validate="{
                          rules: {
                            required:
                              field.required == 1 &&
                              field.prod_danger_id == peligro.id,
                          },
                        }" />
                </div>
                <span class="text-danger span-error small">
                  {{ errors.first('formulario-cas.' + field.label) }}
                </span>
              </div>
            </div>
            <div v-if="!ari" class="d-flex align-items-center justify-content-end">
              <div slot="footer" class="dialog-footer">
                <b-button class="mr-2" @click="(modalpeligro = false)" variant="light">
                  <i class="fa fa-close" />
                  Cancelar
                </b-button>
                <b-button @click="btnGuardarComponenteValores(peligro.danger_fields, peligro.componente,)" variant="primary">
                  <i class="fa fa-floppy-o fa-lg"></i>
                  Guardar
                </b-button>
              </div>
            </div>
          </form>
        </b-modal>

        <div v-if="readyComponent">

            <div class="d-flex align-items-center justify-content-end mb-2 content-header">
              <div class="w-100 w-full">
                <b-form-input id="buscar" name="buscar" type="text" placeholder="Buscar Componente..."
                  v-model="parametrosBuscador.buscar"></b-form-input>
              </div>
              <div class="w-100 d-flex align-items-center justify-content-between">
                <div>
                  <b-button @click="componenteSegunPeligro" variant="primary" class="ml-2">
                    <i class="fa fa-search fa-lg"></i>
                    Buscar
                  </b-button>
                  <b-button @click="limpiarComponenteSegunPeligro" variant="light" class="ml-2">
                    <i class="fa fa-eraser fa-lg"></i>
                    Limpiar
                  </b-button>
                </div>
                <div>
                  <b-button v-if="!ari" @click="crearPeligro" variant="primary">
                    <i class="fa fa-plus fa-lg mr-1"></i>
                    Nuevo componente
                  </b-button>
                  <b-dropdown variant="outline-primary" class="m-md-2">
                    <template #button-content>
                      <i class="fa fa-list"></i>
                      <span class="mx-2">Procesar información</span>
                    </template>

                    <b-dropdown-item @click="onHandleDownloadDanger(peligro)">
                      <i class="fa fa-download text-info"></i>
                      Descargar
                    </b-dropdown-item>
                    <b-dropdown-item @click="onHandleLoadDanger(peligro)">
                      <i class="fa fa-upload text-info"></i>
                      Cargar datos 
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>

            <!-- Tabla -->
            <b-table class="m-0" bordered responsive striped hover empty-text="No hay información para mostrar"
                thead-tr-class="table-active" show-empty :items="componentesPeligro.data"
                :fields="columnasComponentesPeligro">
                <template v-slot:cell(name)="data">
                  <b-badge v-if="data.item.approved == 1" variant="success">
                    {{ data.item.name }}
                  </b-badge>
                  <span v-else>{{ data.item.name }}</span>
                </template>
                <template v-slot:cell(active)="data">
                  <b-badge variant="primary" v-if="data.item.active == 1">
                    Activo
                  </b-badge>
                  <b-badge v-else variant="danger">
                    Inactivo
                  </b-badge>
                </template>
                <template v-slot:cell(actions)="data">
                  <a v-b-tooltip.hover @click="
                          buscarValoresComponenteEspecifico(data.item.id)
                        " title="Editar" class="accion">
                    <i class="cui-pencil text-primary icons"></i>
                  </a>
                  <a v-if="!ari" v-b-tooltip.hover :title="data.item.active == 1 ? 'Inactivar' : 'Activar'"
                    class="accion ml-2" @click="activarInactivarComponenteValores(data.item)">
                    <i class="fa fa-close text-danger" v-if="data.item.active == 1" />
                    <i class="fa fa-check text-success" v-else />
                  </a>
                </template>
              </b-table>

            <!-- Paginas -->
            <div class="my-4">
              <el-pagination small :page-sizes="[10, 30, 50, 100]" :page-size="parametrosBuscador.perPage"
              v-model="parametrosBuscador.page" @size-change="setPorPaginaComponentes"
              @current-change="setPaginaComponente" :current-page.sync="parametrosBuscador.page"
              layout="total,sizes, prev, pager, next" :total="componentesPeligro.total"
              class="float-right"></el-pagination>
            </div>
            
        </div>

      </div>

    <!-- Modal para cargar excel con componentes para el peligro -->
    <UploadExcelComponentsToDanger ref="uploadExcelComponentsToDangerRef" />

    <!-- Btn para regresar -->
    <div class="mt-3">
      <b-button to="/cas/parametrizacion" variant="light">
        <i class="fa fa-reply fa-lg"></i>
        Volver a la lista de peligros
      </b-button>
    </div>

  </div>
</template>

<script>

// Generales
import { mapActions, mapMutations, mapState } from 'vuex'

// Componentes
import UploadExcelComponentsToDanger from './fragments/UploadExcelComponentsToDanger.vue';

export default {

  components: {
    UploadExcelComponentsToDanger
  },

  props: {
    ari: {
      type: Boolean,
      default: false,
      required: false,
    },
    closeModal: {
      type: Function,
      default: () => {}
    },
    modalEditDangerCasRef: {
      type: Object,
      default: () => {}
    }
  },

  name: 'cas-crear',

  data: function () {
    return {
      columnasComponentesPeligro: [
        {
          key: 'name',
          label: 'Componente',
          sortable: false,
          thStyle: {
            'min-width': '220px !important',
            width: '220px !important',
          },
        },
        {
          key: 'cas_complete',
          label: 'Numero de CAS',
          sortable: true,
          thStyle: {
            'min-width': '120px !important',
            width: '120px !important',
          },
        },
        {
          key: 'active',
          label: 'Estado',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: {
            width: '120px',
            'min-width': '120px',
          },
        },
        {
          key: 'actions',
          label: 'Acciones',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: {
            width: '120px',
            'min-width': '120px',
          },
        },
      ],
      accion: '',
      modalpeligro: false,
      searchComponent: '',
      typeCasTemporary: [],
      readyComponent: false
    }
  },

  async created() {

    this.setCurrentDangerActive(null)

    await this.listarTipoCas().then(() => this.typeCasTemporary = this.tiposCas)
    if (this.ari) {
      _.remove(this.tiposCas, function (cas) {
        return cas.lista != 'TLV'
      })
    }
    
    if (this.$route.params.id) {
      this.loadDataInitial()
    } 
    else {
      let peligro = this.tiposCas[this.tiposCas.length - 1]
      await this.componenteSegunPeligro(peligro.id)
    }

    this.readyComponent = true

  },

  beforeDestroy() {
    this.resetearComponentes()
  },

  methods: {
    ...mapActions('nuevocas', [
      'listarTipoCas',
      'ListarComponentes',
      'listarComponenteSegunPeligro',
      'buscarValoresComponente',
      'setPorPaginaComponentes',
      'setPaginaComponente',
      'estadoComponenteValores',
      'crearComponenteValores',
      'actualizarComponenteValores',
      'downloadRegistersDanger'
    ]),
    ...mapMutations('nuevocas', [
      'setFiltroBuscador',
      'resetFiltroBuscador',
      'setComponentesPeligro',
      'resetearComponentes',
      'setTiposCas',
      'setCurrentDangerActive'
    ]),

    loadDataInitial() {
      const id = this.$route.params.id  
      const newCasItems = this.tiposCas.filter(x => x.id == id)

      this.setCurrentDangerActive(this.tiposCas.find(x => x.id == id))
      this.setTiposCas(newCasItems)
      this.componenteSegunPeligro(id)
    },

    async componenteSegunPeligro(peligro_id) {
      this.setFiltroBuscador({
        peligro_id: peligro_id,
        buscar: this.parametrosBuscador.buscar,
        page: 1,
      })
      await this.listarComponenteSegunPeligro()
    },

    async limpiarComponenteSegunPeligro() {
      this.resetFiltroBuscador()
      await this.listarComponenteSegunPeligro()
    },

    async crearPeligro() {
      this.searchComponent = ''
      this.accion = 'Crear'
      this.modalpeligro = true
      this.tiposCas.forEach(async (tp) => {
        tp.componente = ''
        if (tp.id == this.parametrosBuscador.peligro_id) {
          tp.danger_fields.forEach(async (df) => {
            delete df.value
          })
        }
      })
    },

    async buscarValoresComponenteEspecifico(componente_id) {
      this.searchComponent = ''
      let data = {
        componente_id: componente_id,
        peligro_id: this.parametrosBuscador.peligro_id,
      }
      await this.buscarValoresComponente(data)
      await this.ListarComponentes(componente_id)
      this.tiposCas.forEach(async (tp) => {
        if (tp.id == this.parametrosBuscador.peligro_id) {
          tp.componente = componente_id
          tp.danger_fields.forEach(async (df) => {
            let valor = this.valoresComponente.find((v) => v.id === df.id)
            df.value = ''
            if (valor) {
              if (df.type == 1) {
                df.value = JSON.parse(valor.value)
              } else if (df.type == 3 || df.type == 4) {
                df.value = parseInt(valor.value)
              } else {
                df.value = valor.value
              }
            }
          })
        }
      })

      this.accion = 'Editar'
      this.modalpeligro = true

      await this.listarComponenteSegunPeligro()
    },

    async activarInactivarComponenteValores(item) {
      let data = {
        activo: item.active,
        componente_id: item.id,
        peligro_id: this.parametrosBuscador.peligro_id,
      }
      await this.estadoComponenteValores(data)
    },

    async btnGuardarComponenteValores(valores, componente_id) {
      valores.forEach((val) => {
        if (val.type === 4) {
          if (val.value === undefined) {
            val.value = null
          }
        }
      })
      this.$validator.validateAll('formulario-cas').then(async (result) => {
        if (result) {
          let data = {
            valores: valores,
            componente_id: componente_id,
          }
          if (this.accion == 'Crear') {
            await this.crearComponenteValores(data).then(() => {
              this.modalpeligro = false
            })
          } else if (this.accion == 'Editar') {
            await this.actualizarComponenteValores(data).then(() => {
              this.modalpeligro = false
            })
          }
          if (this.ari) {
            this.$emit('obtenerDatosPorProducto')
          }

          if (this.$route.params.id) this.loadDataInitial()

        }
      })
    },

    async searchListarComponentes() {
      await this.ListarComponentes(this.searchComponent)
    },

    async onHandleDownloadDanger(danger){
      await this.downloadRegistersDanger({ danger })
    },

    onHandleLoadDanger(danger) {

      this.setCurrentDangerActive(this.tiposCas.find(x => x.id == danger.id))
      this.$refs.uploadExcelComponentsToDangerRef.showModal()

    }

  },

  computed: {
    ...mapState('nuevocas', [
      'tiposCas',
      'componentes',
      'parametrosBuscador',
      'componentesPeligro',
      'valoresComponente',
    ]),

    ...mapState('nuevocas', {
      currentDangerActive: 'currentDangerActive'
    }),

  },

  destroyed() {
    this.setTiposCas(this.typeCasTemporary)
    this.closeModal()
  }

}
</script>

<style scoped>
.el-select-dropdown__item {
  white-space: normal;
  overflow: unset;
  height: auto;
  line-height: 170%;
  padding-top: 10;
  padding-bottom: 10;
}
.modal-container {
  background: rgba(0, 0, 0, 0.5);
}
.custom-span-component {
    background-color: #4dbd74;
    color: #ffffff;
    padding: 2px 2px;
    border-radius: 6px;
    font-size: inherit;
    font-weight: normal;
    display: inline-block;
    line-height: 1;
}

@media (min-width: 0px) and (max-width: 668px) {
    
  .content-header {
    display: block !important;
  }  

  .content-header div {
    display: block !important;
  }

  .content-header div button,
  .content-header button {
    display: block !important;
    width: 100% !important;
    margin: 4px 0 !important;
  }  

}

</style>
